import { motion } from "framer-motion";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1758518730384-be3d205838e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjBoYW5kc2hha2UlMjBtZWV0aW5nJTIwb2ZmaWNlfGVufDB8fHx8MTc4MTM4NjMzMXww&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-altin-bg"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-7"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="gold-divider" />
              <span className="overline">Who We Are</span>
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl leading-[1.05] text-altin-ink tracking-tight">
              Your Strategic <br />
              <span className="italic text-altin-gold">Business Partner</span>{" "}
              across borders.
            </h2>
            <p className="mt-8 text-lg text-altin-muted leading-relaxed font-light max-w-2xl">
              Altin Link Ltd. Şti. is a Türkiye-based commercial brokerage and
              business consulting company dedicated to building strong business
              relationships across borders. We serve as a professional bridge
              between manufacturers, suppliers, investors, distributors and
              corporate buyers.
            </p>
            <p className="mt-5 text-base text-altin-muted leading-relaxed max-w-2xl">
              Our commitment is built on integrity, professionalism,
              confidentiality and long-term business value.
            </p>

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-8">
              <div
                data-testid="vision-card"
                className="border-l border-altin-gold pl-6"
              >
                <div className="overline mb-2">Our Vision</div>
                <p className="text-altin-ink leading-relaxed">
                  To become a leading international business bridge connecting
                  opportunities between Türkiye, Europe, the Middle East and
                  emerging global markets.
                </p>
              </div>
              <div
                data-testid="mission-card"
                className="border-l border-altin-gold pl-6"
              >
                <div className="overline mb-2">Our Mission</div>
                <p className="text-altin-ink leading-relaxed">
                  To simplify international business relationships through
                  trusted brokerage, strategic networking and market access
                  solutions that create measurable value for our clients.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="lg:col-span-5 relative lg:sticky lg:top-28"
          >
            <div className="absolute -top-6 -right-6 w-full h-full bg-altin-gold/15 -z-10" />
            <img
              src={ABOUT_IMG}
              alt="Corporate handshake — partnership and trust"
              className="w-full h-[520px] object-cover"
            />
            <div className="mt-6 text-xs uppercase tracking-[0.25em] text-altin-muted text-right">
              Integrity · Professionalism · Confidentiality
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
